export const ASSIGNEE_BUTTON_TEST_ID =
	'software-board.board-container.board.card-container.card.assignee-field.button';

export const ASSIGNEE_STATIC_TEST_ID =
	'software-board.common.fields.assignee-field-static.avatar-wrapper';
